<template>
  <section>      
    <v-list
      subheader
      two-line
    >
      <v-list-item-group>
        <v-list-item 
          v-for="(document, index) in documents" 
          :key="index" 
          :dense="true" 
          :selectable="false"
        >
          <v-list-item-avatar>
            <v-icon>{{ document.imageable ? 'image' : 'description' }}</v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>              
              {{ document.document_type.name }}
            </v-list-item-title>

            <v-list-item-subtitle v-if="document.content.filename">
              <span>Arquivo: {{ document.content.filename }}</span>
            </v-list-item-subtitle>

            <v-list-item-subtitle>              
              <v-chip
                small
                class="mt-1 mb-1"
                :color="fetchStatusColor(document.status.raw)"
              >
                {{ document.status.label }}
              </v-chip>              
            </v-list-item-subtitle>

            <v-list-item-subtitle>
              <p
                v-if="document.reason"
                class="mb-0"
              >
                <strong class="mr-1">
                  Motivo Rejeição: {{ document.reason }}
                </strong>                
              </p>                                   
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action style="flex-direction: row; align-items: center;">
            <OrderDocumentUploadModalPublic
              :orderToken="secretToken"
              :document="document" 
              @close="closeUploadModal()"                 
            />  

            <OrderDocumentDownloadButton   
              :order="order"
              :document="document"
            />

            <OrderDocumentInfoButtonPublic
              v-if="document.content.url"              
              :orderToken="secretToken"
              :documentId="document.id"
              @close="fetchDocuments()"
            />
          </v-list-item-action>
        </v-list-item>        
      </v-list-item-group>
    </v-list> 
  </section>
</template>

<script>
  import OrderService from '@/services/order.service';
  import OrderDocumentUploadModalPublic from './OrderDocumentUploadModalPublic.vue';
  import OrderDocumentDownloadButton from './OrderDocumentDownloadButton.vue';
  import OrderDocumentInfoButtonPublic from './OrderDocumentInfoButtonPublic.vue';
  import { documentStatusColor } from '@/util/document-status-color';
import { mapActions } from 'vuex';

  export default {
    name: 'OrderDocumentListPublic',

    components: {
      OrderDocumentUploadModalPublic,
      OrderDocumentDownloadButton,
      OrderDocumentInfoButtonPublic
    },

    props: {
      order: {
        type: Object,
        required: true
      },

      secretToken: {
        type: String,
        required: true
      }
    },

    data: () => ({
      documents: [],
    }), 

    watch: {
      order: {
        immediate: true,
        handler() {
          this.fetchDocuments();
        }
      }
    },

    methods: {
      fetchDocuments() {
        OrderService.listDocumentsPublic(this.secretToken).subscribe(response => {
          this.documents = response;
        });
      },

      closeUploadModal() {    
        this.fetchOrder(this.secretToken);  
        this.fetchDocuments();
      },

      fetchStatusColor(statusCode) {
        return documentStatusColor(statusCode);
      },

      ...mapActions('order', { 
        fetchOrder: 'SHOW_PUBLIC',        
      }),
    },
  };
</script>
